import { Component } from "react";
import PropTypes from "prop-types";
import { getDisplayDecision } from "./displayDecisionData/getDisplayDecision";
import RsftWelcomeMessage from "./RsftWelcomeMessage";

class WelcomeMessageContainer extends Component {
  async componentDidMount() {
    const {
      minorCountries,
      platform,
      requestWelcomeMessage,
      disableWelcomeMessage
    } = this.props;

    const { shouldDisplay, resolvedDeliveryCountry } =
      await getDisplayDecision(minorCountries);

    if (!shouldDisplay) {
      disableWelcomeMessage();

      return;
    }

    requestWelcomeMessage(platform, resolvedDeliveryCountry);
  }

  render() {
    if (!this.props.showWelcomeMessage) {
      return null;
    }

    return <RsftWelcomeMessage />;
  }
}

WelcomeMessageContainer.propTypes = {
  minorCountries: PropTypes.object.isRequired,
  platform: PropTypes.string.isRequired,
  requestWelcomeMessage: PropTypes.func.isRequired,
  showWelcomeMessage: PropTypes.bool.isRequired,
  disableWelcomeMessage: PropTypes.func.isRequired
};

export default WelcomeMessageContainer;
